import React from "react";
import PropTypes from "prop-types";

const PauseButtonIcon = ({ color = "#FFFFFF", size = 20 }) => (
  <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect width={size} height={size} rx="4" />
      <path
        d="M5.5 3h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm7 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"
        fill={color}
      />
    </g>
  </svg>
);

PauseButtonIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default PauseButtonIcon;
